import React from 'react';

const McpSection: React.FC = () => {
  return (
    <section id="mcp" className="py-20 bg-slate-800 border-t border-slate-700">
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex items-center mb-8">
          <div className="h-8 w-8 bg-amber-500 rounded-sm mr-4 flex items-center justify-center font-bold text-slate-900 shadow-lg shadow-amber-500/50">M</div>
          <h2 className="text-2xl font-bold text-white">Power Your AI Agents (MCP)</h2>
        </div>
        <p className="text-slate-400 mb-6 text-lg">
          Connect ProGeoData directly to <span className="text-white font-medium">Claude Desktop</span> or <span className="text-white font-medium">Cursor AI</span>. 
          Give your agents real-time access to professional license data. Included in <strong>Agent Pro</strong>.
        </p>
        
        <div className="bg-slate-950 rounded-lg p-6 border border-slate-700 font-mono text-sm relative overflow-hidden group">
            <div className="absolute top-2 right-2 flex space-x-1">
                <div className="w-3 h-3 rounded-full bg-slate-700"></div>
                <div className="w-3 h-3 rounded-full bg-slate-700"></div>
                <div className="w-3 h-3 rounded-full bg-slate-700"></div>
            </div>
          <div className="text-slate-500 mb-4 select-none">// claude_desktop_config.json</div>
          <pre className="text-slate-300 overflow-x-auto p-2">
{`{
  "mcpServers": {
    "progeodata": {
      "command": "npx",
      "args": ["-y", "progeodata-mcp", "--api-key", "YOUR_AGENT_KEY"]
    }
  }
}`}
          </pre>
        </div>
      </div>
    </section>
  );
};

export default McpSection;
